export function normalizeSiteNickname(value: string): string {
  const nickname = value.trim();
  if (!nickname || [...nickname].length > 60 || /[\u0000-\u001f\u007f-\u009f\u200b-\u200f\u202a-\u202e\u2060-\u206f\ufeff]/u.test(value)) throw new Error('昵称请输入1至60个字符，不能只含空白或包含控制字符');
  return nickname;
}

// Decode then redraw: no uploaded metadata, animation, SVG or original file
// payload is sent to the server. Only a bounded static PNG becomes account data.
export async function encodeSiteAvatar(file: File): Promise<string> {
  if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type) || !file.size || file.size > 8 * 1024 * 1024) throw new Error('请选择8MB以内的PNG、JPEG或WebP图片');
  const source = await createImageBitmap(file);
  try {
    if (!source.width || !source.height || source.width > 8192 || source.height > 8192 || source.width * source.height > 32_000_000) throw new Error('图片尺寸过大，请选择8192像素以内的图片');
    const canvas = document.createElement('canvas'), context = canvas.getContext('2d');
    if (!context) throw new Error('当前浏览器无法处理头像，请重试');
    for (const maximum of [256, 192, 128]) {
      const scale = Math.min(1, maximum / Math.max(source.width, source.height));
      canvas.width = Math.max(1, Math.round(source.width * scale)); canvas.height = Math.max(1, Math.round(source.height * scale));
      context.drawImage(source, 0, 0, canvas.width, canvas.height);
      const png = canvas.toDataURL('image/png');
      if (png.length - 22 <= Math.ceil(128 * 1024 / 3) * 4) return png;
    }
    throw new Error('头像转换后仍超过128KB，请选择更小的图片');
  } finally { source.close(); }
}
